import { AntragsType, InputError } from '@ebeihilfe/core';
import { BaseDynamicFormElementInterface } from './base-dynamic-form-element.interface';

export class BaseDynamicFormElement<T> implements BaseDynamicFormElementInterface<T> {
  public ariaLabel: string;
  public controlType: string;
  public errors: InputError[];
  public hide: ((model: { antragsArt: AntragsType }) => boolean) | undefined;
  public hint: string | undefined;
  public key: string;
  public label: string;
  public max: string;
  public min: string;
  public options: { key: string; value: string | number; label: string }[];
  public order: number;
  public placeholder: string;
  public required: boolean;
  public requiredIf: string | undefined;
  public requiredTrue?: boolean;
  public type: string;
  public pattern: RegExp | string;
  public value: T | undefined;

  constructor(options?: Partial<BaseDynamicFormElementInterface<T>>) {
    this.value = options?.value;
    this.key = options?.key ?? '';
    this.label = options?.label ?? '';
    this.ariaLabel = options?.ariaLabel ?? this.label;
    this.required = !!options?.required;
    this.order = options?.order === undefined ? 1 : options.order;
    this.controlType = options?.controlType ?? '';
    this.placeholder = options?.placeholder ?? '';
    this.type = options?.type ?? '';
    this.min = options?.min ?? '';
    this.max = options?.max ?? '';
    this.hint = options?.hint;
    this.options = options?.options ?? [];
    this.errors = options?.errors ?? [];
    this.hide = options?.hide;
    this.requiredIf = options?.requiredIf;
    this.pattern = options?.pattern ?? '';
    this.requiredTrue = options?.requiredTrue;
  }
}
